import React from 'react'

const Field = ({ children, bold, sanSerif, longForm, className="" }) => {
	return (
		<div className={`field ${className}`}>
			{children}
			<style jsx>{`
				div {
					font-weight: ${bold ? 700 : 400};
					font-family: ${sanSerif ? 'Graphik' : 'Elizeth'};
					font-size: ${longForm ? '12px' : '20px'};
					line-height: ${longForm ? '1.28' : '26px'};
					padding-right: 1.25rem;
					min-width: 0;
					word-break: break-word;
				}
			`}</style>
		</div>
	)
}

export default Field
